import 'react-image-lightbox/style.css';

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { routes } from 'src/constants/constants';

import { FaqStyled } from '../components/faq/Faq.styled';
import { FaqQuestion } from '../components/faq/FaqQuestion';
import { Tabs } from '../components/faq/Tabs';
import { Footer } from '../components/Footer/Footer';
import { Header } from '../components/Header/Header';
import { getFaqContent } from '../helper/getFaqContent';
import { useLocation } from '../react-router-hooks';

export const FaqContentScreen = () => {
  const { location } = useLocation();
  const { t } = useTranslation();
  const { idCategory, idSubCategory } = useParams();
  const faqContent = getFaqContent();
  const content = faqContent[idCategory];
  const [customerTabState, setCustomerTabState] = useState('HUK');
  const [paramsState, setParamsState] = useState<any>();

  useEffect(() => {
    window.scrollTo(0, 0);
    setParamsState(location.state);
  }, [location]);

  const subCategory =
    content.subCategories &&
    content.subCategories.find(item => item.title.trim() === idSubCategory);

  const customerInfo =
    subCategory &&
    subCategory.customer &&
    subCategory.customer.find(item => item.name.trim() === customerTabState);

  //idSubCategory === 'general' means that there isn't subCategories
  const questions =
    idSubCategory === 'general'
      ? content.questions
      : subCategory && subCategory.questions;

  return (
    <div className="root">
      <Header />
      <div id="main" className="main" style={{ paddingTop: 73 }}>
        <FaqStyled.NavigationMainContainer>
          <FaqStyled.NavigationContainer>
            <FaqStyled.ImageNavigation src={require('../assets/faqhome.svg')} />
            <FaqStyled.NavigationText
              to={{ pathname: routes.HOME, state: paramsState }}
            >
              {t('Start ')}
            </FaqStyled.NavigationText>
            <FaqStyled.Divider>
              <img
                height={16}
                width={16}
                src={require('../assets/navigation_separator.svg')}
              />
            </FaqStyled.Divider>
            <FaqStyled.NavigationText
              to={{ pathname: routes.FAQMAIN, state: paramsState }}
            >
              {content.mainCategory}
            </FaqStyled.NavigationText>
            {idSubCategory !== 'general' && (
              <FaqStyled.Divider>
                <img
                  height={16}
                  width={16}
                  src={require('../assets/navigation_separator.svg')}
                />
              </FaqStyled.Divider>
            )}
            {idSubCategory !== 'general' && (
              <FaqStyled.NavigationText
                to={{
                  pathname: routes.FAQSUBCATEGORY.replace(
                    ':idCategory',
                    idCategory
                  ),
                  state: paramsState
                }}
              >
                {content.title}
              </FaqStyled.NavigationText>
            )}
          </FaqStyled.NavigationContainer>
        </FaqStyled.NavigationMainContainer>
        <FaqStyled.ContainerMain style={{ marginTop: 80 }}>
          <FaqStyled.Container>
            <FaqStyled.TitlePage>
              {subCategory && subCategory.title
                ? subCategory.title
                : content.title}
            </FaqStyled.TitlePage>
            {subCategory && subCategory.generalMessage ? (
              <FaqStyled.SubTitle
                dangerouslySetInnerHTML={{
                  __html: subCategory.generalMessage
                }}
              />
            ) : (
              <FaqStyled.SubTitle
                dangerouslySetInnerHTML={{
                  __html: content.generalMessage
                }}
              />
            )}
            {questions &&
              questions.map((item, index) => (
                <FaqQuestion key={index} question={item} id={index} />
              ))}

            {subCategory && subCategory.customer && (
              <>
                <Tabs
                  tabSelect={customerTabState}
                  onTabChange={(customer: string) => {
                    setCustomerTabState(customer);
                  }}
                ></Tabs>
                {customerInfo.name === customerTabState &&
                  customerInfo.questions &&
                  customerInfo.questions.map((item, index) => (
                    <div key={index} style={{ marginTop: 40 }}>
                      <FaqQuestion question={item} id={index} />
                    </div>
                  ))}
              </>
            )}

            {subCategory && subCategory.video && (
              <div style={{ textAlign: 'center' }}>
                <a
                  href={subCategory.video}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'inline-block' }}
                >
                  <img
                    src={require(`../assets/${subCategory.image}`)}
                    width="300"
                    alt={subCategory.title}
                  />
                </a>
              </div>
            )}
          </FaqStyled.Container>
        </FaqStyled.ContainerMain>
      </div>
      <Footer />
    </div>
  );
};
